import { useEffect } from "react";

import { AiOutlineLoading3Quarters } from "react-icons/ai";

import {
  Dialog,
  DialogTitle,
  DialogActions,
} from "V2.0/components/DialogFullWidth";
import { Button } from "V2.0/common/button";

import EvalRunUnified from "./EvalRunUnified";

import useEvalRun from "./useEvalRun";

export default EvalRun;


function EvalRun(props) {
  const { workspaceId, onClose, evalRun } = props;

  const {
    evalRun: evalRunWithResultsAndReports,
    isEvalRunLoading,
    fetchEvalRun,
  } = useEvalRun(workspaceId, evalRun._id);

  useEffect(() => {
    if (workspaceId && evalRun._id) {
      fetchEvalRun();
    }
  }, [workspaceId, evalRun._id]);

  return (
    <Dialog className="" size="full" open={true} onClose={onClose}>
      <DialogTitle className="shrink-0 sm:*:w-auto *:w-auto p-4 border-none shadow-sm">
        {evalRun?.templateName || "Test run"}
      </DialogTitle>

      <div className="flex-1 min-h-0 h-full overflow-auto flex flex-col gap-y-4 px-8 py-4">
        {isEvalRunLoading ? (
          <div className="flex w-full h-full items-center justify-center">
            <AiOutlineLoading3Quarters className="animate-spin" />
          </div>
        ) : (
          <EvalRunUnified evalRun={evalRunWithResultsAndReports} />
        )}
      </div>

      <DialogActions className="shrink-0 sm:*:w-auto *:w-auto px-4 py-3 shadow-[0_-1px_2px_-1px_rgba(0,0,0,0.1)]">
        <Button outline onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
